import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import styles from './Navbar.module.css';

export default function Navbar({ theme = 'light', wordmark, navLinks = [] }) {
  const navigate = useNavigate();
  const { t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavLink = (e, href) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`${styles.nav} ${styles[theme]}`}>
      <div className={styles.left}>
        <button
          className={`${styles.back} ${scrolled ? styles.backHidden : ''}`}
          onClick={() => navigate('/')}
          aria-label="Go back"
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9 2L4 7L9 12" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {t('back')}
        </button>
        {wordmark && (
          <button
            className={`${styles.wordmarkLeft} ${scrolled ? styles.wordmarkLeftVisible : ''}`}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Scroll to top"
          >
            {wordmark}
          </button>
        )}
      </div>

      <div className={styles.right}>
        <LanguageSwitcher theme={theme} />
        {navLinks.map(link => (
          <a
            key={link.key}
            href={link.href}
            className={styles.navLink}
            onClick={e => handleNavLink(e, link.href)}
          >
            {t(link.key)}
          </a>
        ))}
      </div>
    </nav>
  );
}
